import React from 'react'
import { ATTableRowCell } from './ATTableProps'

const TableRowCell: React.FC<ATTableRowCell> = ({ item, column }) => {
  return (
    <td> {column.render ? column.render(column, item) : item[column.key]}</td>
  )
}

export default TableRowCell
